import { Chip } from '@mui/material';

interface ActionChipProps {
  action: string;
  size?: 'small' | 'medium';
}

/**
 * ActionChip - Audit log action display with color coding
 * create = blue, update = orange, delete = red, view = gray
 */
export const ActionChip = ({ action, size = 'small' }: ActionChipProps) => {
  const getActionColor = (actionType: string): string => {
    const actionLower = actionType.toLowerCase();
    if (actionLower.includes('create')) {
      return '#2196f3'; // blue
    }
    if (actionLower.includes('update') || actionLower.includes('edit')) {
      return '#ff9800'; // orange
    }
    if (actionLower.includes('delete') || actionLower.includes('remove')) {
      return '#f44336'; // red
    }
    if (actionLower.includes('view') || actionLower.includes('read')) {
      return '#9e9e9e'; // gray
    }
    return '#90caf9'; // default primary
  };

  return (
    <Chip
      label={action.toUpperCase()}
      size={size}
      sx={{
        backgroundColor: getActionColor(action),
        color: '#fff',
        fontWeight: 'bold',
      }}
    />
  );
};
